"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwrapDataContext = exports.wrapDataContext = void 0;
const vlx_types_1 = require("@sundaysky/vlx-types");
const wrapDataContext = (dataContext) => {
    // wrap the data context first, to match how hub defines logic (backwards-compatibility)
    if (dataContext === null || dataContext === void 0 ? void 0 : dataContext[vlx_types_1.DATAELEMENTS]) {
        return dataContext;
    }
    else {
        return { [vlx_types_1.DATAELEMENTS]: dataContext };
    }
};
exports.wrapDataContext = wrapDataContext;
const unwrapDataContext = (dataContext) => {
    if (dataContext === null || dataContext === void 0 ? void 0 : dataContext[vlx_types_1.DATAELEMENTS]) {
        return dataContext[vlx_types_1.DATAELEMENTS];
    }
    else {
        return dataContext;
    }
};
exports.unwrapDataContext = unwrapDataContext;
//# sourceMappingURL=dataContext.js.map